import { userStorageKey } from './../constants/defaultValues';
export function authHeader() {
    try {
        const token = localStorage.getItem(userStorageKey);
        const user = JSON.parse(token);
        return { Authorization: `Bearer ${user.access_token}` };
    }
    catch {
        return { Authorization: '' };
    }
}